module.exports = __webpack_public_path__ + "../resources/img/@sign.21b5d898.png";